import React from 'react'
import { Routes, Route } from "react-router-dom";
import Home from './Pages/Home';
import VehicleAnalysis from './Pages/VehicleAnalysis';
import DealerAnalysis from './Pages/DealerAnalysis';
import Chat from './Pages/Chat/Chat';
import PriceMismatch from './Pages/PriceMismatch';
import Login from './Component/Common/Login';
import Layout from './Component/Layout';
import DealVault from './Pages/DealVault';

const AppRoutes = () => {
  return (
    <Routes>
    <Route path="/login" element={<Login />} />
    <Route
      path="/*"
      element={
        <Layout>
          <Routes>
            <Route index element={<VehicleAnalysis />} />
            <Route path='/deal-vault' element={<DealVault />} />
            <Route path="/dealer-analysis" element={<DealerAnalysis />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/price-mismatch" element={<PriceMismatch />} />
          </Routes>
        </Layout>
      }
    />
  </Routes>
  )
}

export default AppRoutes